"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconDashboard = function IconDashboard(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16px",
    height: "16px",
    className: (0, _classnames.default)('Icon', 'IconDashboard', className),
    style: style,
    viewBox: "0 0 21 20"
  }, _react.default.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.3",
    transform: "translate(1 1)"
  }, _react.default.createElement("rect", {
    width: "8",
    height: "5",
    rx: "1"
  }), _react.default.createElement("rect", {
    width: "8",
    height: "10",
    y: "8",
    rx: "1"
  }), _react.default.createElement("path", {
    d: "M12.282 0h5.436c.446 0 .607.046.77.134.163.087.291.215.378.378.088.163.134.324.134.77v7.436c0 .446-.046.607-.134.77a.909.909 0 0 1-.378.378c-.163.088-.324.134-.77.134h-5.436c-.446 0-.607-.046-.77-.134a.909.909 0 0 1-.378-.378c-.088-.163-.134-.324-.134-.77V1.282c0-.446.046-.607.134-.77a.909.909 0 0 1 .378-.378c.163-.088.324-.134.77-.134z"
  }), _react.default.createElement("rect", {
    width: "8",
    height: "5",
    x: "11",
    y: "13",
    rx: "1"
  })));
};

var _default = IconDashboard;
exports.default = _default;